import { GET_ACTIVITY_LOG_SUCCESS } from './actions';

const initialState = {
  logs: []
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_ACTIVITY_LOG_SUCCESS:
      return {
        ...state,
        logs: action.data
      };
    default:
      return state;
  }
};

export default reducer;
